import { BaseApi } from './BaseApi';
export class IdwInfoApi extends BaseApi {
    constructor(config) {
        super(config);
    }
    getBaseInfo() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-info'),
            method: 'GET',
        });
    }
    getIdwInfoWithStatistic() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-info/statistic'),
            method: 'GET',
        });
    }
    updateIdwInfo(data) {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-info'),
            method: 'PATCH',
            data,
        });
    }
    idwNameCanBeTaken(name) {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-info/name-can-be-taken'),
            method: 'get',
            params: {
                name,
            },
        });
    }
    isIdwAccount() {
        return this.providers.makeRequest({
            route: this.buildRoute('idw-info/is-idw-account'),
            method: 'get',
        });
    }
}
//# sourceMappingURL=idwInfoApi.js.map